import React, { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { viewImage } from '../../CommonUtils/viewImage';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import moment from 'moment';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { allowAlphabetAndSpacesOnly } from '../../CommonUtils/CommonValidations';
import { FaEye } from 'react-icons/fa';
export default function Ffcafeedbackandrecmnd() {
    const hasFetchedData = useRef(false)
    const [isFormValid, setIsFormValid] = useState(true);
    const [displayFile, setdisplayFile] = useState(false)
    const [missingFields, setMissingFields] = useState([]);
    const [displayProceedingFile, setdisplayProceedingFile] = useState(false)
    const FfcaFeedbackValidation = Yup.object().shape({
        recmndOptn: Yup.string().required(ERROR_MSG).nullable(),
        uploadPdfhidden: Yup.string().when(['uploadPdf', "isFurnishedInfo"], {
            is: (uploadPdf, isFurnishedInfo) => !uploadPdf && isFurnishedInfo === true,
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        proceedingUploadUniversityhidden: Yup.string().when(['proceedingUploadUniversity', "isFurnishedInfo"], {
            is: (proceedingUploadUniversity, isFurnishedInfo) => !proceedingUploadUniversity && isFurnishedInfo === true,
            then: Yup.string().required(ERROR_MSG),
            otherwise: Yup.string().nullable(),
        }),
        dateOfInsp: Yup.string().required(ERROR_MSG).nullable(),
        placeOfInsp: Yup.string().required(ERROR_MSG).nullable(),

        anyDef4NewCourse: Yup.string().required(ERROR_MSG).nullable(),
        consolidDefReport: Yup.string().required(ERROR_MSG).nullable(),


    })
    const FfcafeedbackandrecmndFormik = useFormik({
        initialValues: {
            recmndOptn: "",
            uploadPdfhidden: "",
            isFurnishedInfo: false,
            uploadPdf: "",
            dateOfInsp: "",
            placeOfInsp: "",
            proceedingUploadUniversity: "",
            proceedingUploadUniversityhidden: "",
            anyDef4NewCourse: "",
            consolidDefReport: ""
        },
        validationSchema: FfcaFeedbackValidation,
        onSubmit: (values) => {
            if (values.isFurnishedInfo == false) {
                Swal.fire({
                    text: 'Please Accept the terms and Conditions.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    backdrop: false,
                });
                return;
            }
            GetFfcaStatusDetails().then(() => {
                Swal.fire({
                    text: 'Are you sure you want to submit?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, submit it!',
                    cancelButtonText: 'No, cancel!',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const url = `${config.url.API_URL}saveFfcaFdBkDetails`;
                        CommonAxiosPost(url, values).then((res) => {
                            if (res?.data?.scode === '01') {
                                successAlertRefresh(res?.data?.sdesc);
                            } else {
                                failureAlert("Failed to Submit");
                            }
                        });
                    } else {
                        console.log('Submission canceled');
                    }
                });
            })
        },
    });

    const [getFeedback, setFeedback] = useState([]);
    const [canRenderForm, setCanRenderForm] = useState(true);

    const oamdcFieldLabels = {
        "ffca_mem_section": "FFCA Member Section",
        "affl_ffca_document_remarks": "FFCA Document Remarks",
        "affl_ffca_committe_photos": "FFCA Committee Photos",
        "ffca_app": "FFCA App Details Application",
        "affl_inspection_data_details": "Regitered Deed Details",
        "affl_ffca_faculty_availability": "FFCA Faculty Availability",
        "affl_ffca_lab_availability_remarks": "FFCA Lab Availability Remarks",
        "affl_ffca_coll_lab_uploads": "FFCA App Lab Uploads",
        "affl_oamdc_ffca_remarks": "OAMDC FFCA Remarks",
        "affl_ffca_coll_building_uploads": "FFCA Building Uploads",
        "affl_ffca_coll_library_uploads": "FFCA Library Uploads",
        "affl_ffca_coll_playgrnd_uploads": "FFCA Playground Uploads",
        "affl_ffca_coll_clsroom_uploads": "FFCA Classroom Uploads",
        "affl_ffca_plinth_area": "FFCA Plinth Area",
        "affl_ffca_coll_parkingarea_uploads": "FFCA Parking Area Uploads",
        "ffca_deficiencies": "FFCA Deficincies"
    };

    const otherFieldLabels = {
        "ffca_admin_area": "FFCA Admin Area",
        "ffca_build_blocks": "FFCA Build Blocks",
        "ffca_lab_area": "FFCA Lab Area",
        "ffca_mem_section": "FFCA Member Section",
        "ffca_ques_sect_6": "FFCA Question Section 6",
        "fee_due_univ": "Fee Due to University",
        "ffca_link_upload": "FFCA Link Upload",
        "ffca_ques_sect_4": "FFCA Question Section 4",
        "ffca_ques_sect_5": "FFCA Question Section 5",
        "ffca_ques_sect_2": "FFCA Question Section 2",
        "ffca_instruct_area": "FFCA Instruction Area",
        "ffca_ques_sect_3": "FFCA Question Section 3",
        "ffca_ques_sect_1": "FFCA Question Section 1",
        "ffca_deficiencies": "FFCA Deficincies",
        "ffca_geo_location": "FFCA GEO Location"
    };

    function GetFfcaStatusDetails() {
        let url = config.url.API_URL + "getFfcaStatusDetails/final";
        return new Promise((resolve, reject) => {
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    const ffcaStatus = res?.data?.getFfcaStatusDetails[0];
                    let fieldsToFill = [];
                    let fieldLabelsToUse = [];
                    if (ffcaStatus.type === "Oamdc") {
                        fieldLabelsToUse = oamdcFieldLabels;
                    } else {
                        fieldLabelsToUse = otherFieldLabels;
                    }
                    Object.keys(ffcaStatus).forEach((key) => {
                        if (ffcaStatus[key] === 0) {
                            if (fieldLabelsToUse[key]) {
                                fieldsToFill.push(fieldLabelsToUse[key]);
                            }
                        }
                    });
                    if (fieldsToFill.length > 0) {
                        setIsFormValid(false); // Disable form submission if fields are missing
                        Swal.fire({
                            html: `<span style="font-size: 18px; color: #0044cc;">Please fill the following screens:</span><br><span style="font-size: 16px; color: red;">${fieldsToFill.join("<br>")}</span>`,
                            icon: 'warning',
                            confirmButtonText: 'OK',
                            backdrop: false,
                            customClass: {
                                title: 'custom-title',
                                content: 'custom-content'
                            }
                        });
                        setIsFormValid(false);
                        setMissingFields(fieldsToFill);
                        setCanRenderForm(false);
                        reject("Fields not filled");
                    } else {
                        setIsFormValid(true);
                        setCanRenderForm(true);
                        resolve(true);
                    }
                } else {
                    reject("Failed to fetch FFCA details");
                }
            }).catch((error) => {
                console.error("Error in GetFfcaStatusDetails API:", error);
                reject("API error");
            });
        });
    }

    function GetFFcaFeedBackData() {
        let url = config.url.API_URL + "getFfcaFdBkDetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setFeedback(res?.data?.getFfcaFdBkDetails)
                const DATEINSP = res?.data?.getFfcaFdBkDetails[0]?.date_of_insp && moment(res?.data?.getFfcaFdBkDetails[0]?.date_of_insp,
                    'DD/MM/YYYY', true).isValid() ? moment(res?.data?.getFfcaFdBkDetails[0]?.date_of_insp, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                FfcafeedbackandrecmndFormik?.setFieldValue("consolidDefReport", res?.data?.getFfcaFdBkDetails[0]?.consolid_def_report ?? '');
                FfcafeedbackandrecmndFormik?.setFieldValue("recmndOptn", res?.data?.getFfcaFdBkDetails[0]?.recmnd_optn ?? '');

                FfcafeedbackandrecmndFormik?.setFieldValue("isFurnishedInfo", res?.data?.getFfcaFdBkDetails[0]?.is_furnished_info ?? false);

                FfcafeedbackandrecmndFormik?.setFieldValue("dateOfInsp", DATEINSP ?? '');
                FfcafeedbackandrecmndFormik?.setFieldValue("placeOfInsp", res?.data?.getFfcaFdBkDetails[0]?.place_of_insp);
                FfcafeedbackandrecmndFormik?.setFieldValue("anyDef4NewCourse", res?.data?.getFfcaFdBkDetails[0]?.any_def_4new_course);
                FfcafeedbackandrecmndFormik?.setFieldValue("proceedingUploadUniversity", res?.data?.getFfcaFdBkDetails[0]?.proceeding_upload_university);
                FfcafeedbackandrecmndFormik?.setFieldValue("uploadPdf", res?.data?.getFfcaFdBkDetails[0]?.upload_pdf);
                setdisplayFile(true)
                setdisplayProceedingFile(true)
                FfcafeedbackandrecmndFormik.validateForm();
            } else {
                setFeedback([])

            }
        })
    }
    const [FfcaFdbkCount, setffcafdbkcount] = useState('');
    function GetFfcaFdbkCount() {
        let url = config.url.API_URL + `getFfcaFdBkDetailsCount`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data !== undefined) {
                setffcafdbkcount(res?.data)


            } else {
                setffcafdbkcount('')

            }
        })
    }


    useEffect(() => {
        if (!hasFetchedData.current) {

            GetFfcaStatusDetails();
            GetFFcaFeedBackData();
            GetFfcaFdbkCount();
            hasFetchedData.current = true
        }
    }, [])

    // function clearcheckBasedfieldValues(e) {
    //     document.getElementById("uploadPdf").value = null;
    //     document.getElementById("proceedingUploadUniversity").value = null;
    // }
    function clearcheckBasedfieldValues(e) {
        FfcafeedbackandrecmndFormik.setFieldValue("uploadPdfhidden", '')
        FfcafeedbackandrecmndFormik.setFieldValue("proceedingUpsloadUniversityhidden", '')
    }
    return (
        <>
            <CommonFormHeading heading="Feedback for further action" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    {canRenderForm ? (
                        <>
                            <FormikProvider value={FfcafeedbackandrecmndFormik}>
                                <Form onChange={FfcafeedbackandrecmndFormik.handleChange} onSubmit={FfcafeedbackandrecmndFormik.handleSubmit} className='affl-form'>
                                    <bie.Row className="px-2 pt-3 mb-3">
                                        <bie.Row>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='mb-1 field-mandatory' >New Courses Deficiencies Remarks :</label>
                                                <Field as='textarea' name="anyDef4NewCourse" className='form-control mb-2 mt-xl-3 mt-xxl-0' />
                                                <ErrorMessage name="anyDef4NewCourse" component="div" className="text-error" />
                                            </bie.Col>
                                        </bie.Row>
                                        <bie.Row>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='field-mandatory mb-1'>Consolidated Deficiency Report :</label>
                                                <Field as='textarea' name="consolidDefReport" className='form-control mb-2 mt-xl-3 mt-xxl-0' />
                                                <ErrorMessage name="consolidDefReport" component="div" className="text-error" />
                                            </bie.Col>
                                        </bie.Row>
                                        <bie.Row>

                                            <bie.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} className='mb-2'>
                                                <label className='field-mandatory mb-1'>Please select one of the options provided</label>
                                                <Field as='select' name="recmndOptn" className='form-control mb-2'>
                                                    <option value=''>---select---</option>
                                                    <option value="Permanent Affiliation">Permanent Affiliation</option>
                                                    <option value="Suggesting for With - Hold of the process due to the Non submission of the documents and details by the college">Suggesting for With - Hold of the process due to the Non submission of the documents and details by the college</option>
                                                    <option value="Earlier Conditional Affiliation Order may be withdrawn due to the Non-Compliance in rectification of the deficiencies">Earlier Conditional Affiliation Order may be withdrawn due to the Non-Compliance in rectification of the deficiencies</option>
                                                    <option value="Withdrawal of Affiliation may be done due to the observance of Serious deficiencies and violation of University Norms">Withdrawal of Affiliation may be done due to the observance of Serious deficiencies and violation of University Norms</option>
                                                    <option value="Conditional Affiliation Order may be granted">Conditional Affiliation Order may be granted</option>
                                                    <option value="Affiliation for Existing Courses may be granted">Affiliation for Existing Courses may be granted</option>
                                                    <option value="Affiliation for new courses along with the Existing courses may be granted">Affiliation for new courses along with the Existing courses may be granted</option>
                                                    <option value="Affiliation with Addition of Intake for the Existing Courses may be granted">Affiliation with Addition of Intake for the Existing Courses may be granted</option>
                                                </Field>
                                                <ErrorMessage name="recmndOptn" component="div" className="text-error" />

                                            </bie.Col>
                                        </bie.Row>
                                        <bie.Alert variant='danger' className='affl-alert'>
                                            <Field type='checkbox' name="isFurnishedInfo" onChange={(e) => {
                                                // FfcafeedbackandrecmndFormik.setFieldValue("isFurnishedInfo", e.target.checked);
                                                clearcheckBasedfieldValues(e.target.value)
                                            }} /> &emsp;
                                            I undertake the responsibility on the correctness of the information furnished and verified thereon. If the Government / Competent Authority
                                            notices at any point of time that the information furnished above is false or tampered, authorities shall initiate appropriate action as per the law in force.

                                        </bie.Alert>
                                        {FfcafeedbackandrecmndFormik?.values?.isFurnishedInfo === true ? (<>
                                            <bie.Row>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                    <label className='field-mandatory mb-1'>Upload</label>
                                                    {/* <div className='d-flex align-items-center'> */}
                                                    <Field type="hidden" name="uploadPdf" />
                                                    <Field type="file" className="form-control mb-2 mt-3" name="uploadPdfhidden" id="uploadPdf" accept="application/pdf"
                                                        onChange={(e) => {
                                                            setdisplayFile(false)
                                                            let filename = `uploadPdf`
                                                            let path = "/Uploads/AffiliationPDFs/2023/FFCA/Fdbkrecmnd/"
                                                            ImagePdfBucket(e, FfcafeedbackandrecmndFormik, path, "uploadPdf", filename, "pdf")
                                                        }}
                                                    />
                                                    {FfcafeedbackandrecmndFormik?.values?.uploadPdf && !displayFile && (
                                                        <button type='button' className='btn btn-primary' onClick={() => { viewImage(FfcafeedbackandrecmndFormik?.values?.uploadPdf) }}>
                                                            <FaEye size={20} />
                                                        </button>
                                                    )}
                                                    {getFeedback[0]?.upload_pdf && displayFile && (
                                                        <button type='button' className='btn btn-primary' onClick={() => { viewImage(getFeedback[0]?.upload_pdf) }}><FaEye size={20} /></button>
                                                    )}
                                                    {/* </div> */}
                                                    <ErrorMessage name="uploadPdfhidden" component="div" className="text-error" />
                                                </bie.Col>
                                            </bie.Row>
                                            <bie.Row>
                                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                    <label className='field-mandatory mb-1'>Proceedings issued by the University delegating the duty of Inspection  of the College mentioned in the Captioned subject (Pdf)</label>
                                                    {/* <div className='d-flex align-items-center'> */}
                                                    <Field type='hidden' name="proceedingUploadUniversity" />
                                                    <Field type="file" className="form-control" name="proceedingUploadUniversityhidden" id="proceedingUploadUniversity" accept="application/pdf"
                                                        onChange={(e) => {
                                                            setdisplayProceedingFile(false)
                                                            let filename = `proceedingUploadUniversity`
                                                            let path = "/Uploads/AffiliationPDFs/2023/FFCA/Fdbkrecmnd/"
                                                            ImagePdfBucket(e, FfcafeedbackandrecmndFormik, path, "proceedingUploadUniversity", filename, "pdf")
                                                        }} />
                                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>

                                                        {FfcafeedbackandrecmndFormik?.values?.proceedingUploadUniversity && !displayProceedingFile && <button type='button' className='btn btn-primary'
                                                            onClick={() => { viewImage(FfcafeedbackandrecmndFormik?.values?.proceedingUploadUniversity) }}><FaEye size={20} /></button>}
                                                        {getFeedback[0]?.proceeding_upload_university && displayProceedingFile && <button type='button' className='btn btn-primary'
                                                            onClick={() => { viewImage(getFeedback[0]?.proceeding_upload_university) }}><FaEye size={20} /></button>}
                                                    </bie.Col>
                                                    <ErrorMessage name="proceedingUploadUniversityhidden" component="div" className="text-error" />
                                                    {/* </div> */}
                                                </bie.Col>
                                            </bie.Row>
                                        </>) : (<></>)}
                                        <bie.Row>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='field-mandatory mb-1'>Date of the inspection</label>
                                                <Field type='date' name="dateOfInsp" className='form-control' onKeyDown={(e) => { e.preventDefault() }}
                                                    min={new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0]}
                                                    max={new Date().toISOString().split('T')[0]}
                                                />
                                                <ErrorMessage name="dateOfInsp" component="div" className="text-error" />
                                            </bie.Col>
                                        </bie.Row>
                                        <bie.Row>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                <label className='field-mandatory mb-1'>place of the inspection</label>
                                                <Field type='text' name="placeOfInsp" className='form-control' maxLength="300"
                                                    onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} />
                                                <ErrorMessage name="placeOfInsp" component="div" className="text-error" />
                                            </bie.Col>
                                        </bie.Row>
                                        {FfcaFdbkCount === 0 ? (<>
                                            <div className="pt-2 mb-1">
                                                <button type='submit' className='btn btn-success btn-sm float-end rounded mb-1' disabled={!isFormValid}>Submit</button>
                                            </div>
                                        </>) : <div className="pt-2 mb-1 text-end">
                                            <span className="text-success font-weight-bold badge  rounded-pill mb-3 " style={{ padding: "10px 20px", fontSize: "22px", color: "red" }}>Already Submitted</span>
                                        </div>}
                                    </bie.Row>
                                </Form>
                            </FormikProvider>
                        </>
                    ) : (
                        <div>Form cannot be displayed due to missing fields. Please complete the required information.
                            <ul>
                                {missingFields?.map((field, index) => (
                                    <li key={index} style={{ color: "red" }}>{field}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </bie.Container></bie.Container>
        </>
    )
}
